import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../services/session.service';
import { Utils } from '../services/utils.service';

@Pipe({
    name: 'filterBy',
    standalone: true
})
export class FilterByPipe implements PipeTransform {

	constructor(private sessionService: SessionService) {}

	transform<T>(items: Array<T>, fields: Array<string> = [], query: string = ''): Array<T> {
		if (!items) return [];
		if (!fields?.length || !query) return items;

		return Utils.searchObjects<T>(
			items,
			fields,
			query,
			this.sessionService.personalSettings.searchAlgorithm
		);
	}
}
